import * as React from "react";
import { PaymentInstructionLayout } from "../../../../../../../../component/modules/PaymentMethodsList/component/PaymentInstructionLayout.js";
const Swish = () => {
  return /* @__PURE__ */ React.createElement(PaymentInstructionLayout, { info: "checkout.payment.method.swish.info" });
};
export {
  Swish
};
//# sourceMappingURL=Swish.js.map
